import * as User from "./user";
import * as Open from "./open";
import * as Agent from "./agent";
import * as Observe from "./observe";

export default {
  User,
  Open,
  Agent,
  Observe
};
